const routes = [
    {
        path: "/yoksis/operations",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            //permission: "yoksisuniversity_index"
        }
    },
];

export default routes;
